import type WebMaintenanceLogsInstrumentRow from '@/shared/types/reports/WebMaintenanceLogsInstrumentRow'

export const formatMaintenanceLogsInstrumentOptionLabel = (
  row: WebMaintenanceLogsInstrumentRow,
  index: number,
): string => {
  const trimmedSerial = row.serialNumber?.trim()
  const nameSegment = trimmedSerial
    ? `${row.instrumentLabel} (${trimmedSerial})`
    : row.instrumentLabel

  return `${index + 1}. ${[nameSegment, row.departmentName, row.siteName]
    .filter(Boolean)
    .join(' — ')}`
}
